import React from 'react'

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const ProjectoSlider = ({imgs}) => {

    const responsive = {
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
        paritialVisibilityGutter: 90
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
        paritialVisibilityGutter: 50
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        paritialVisibilityGutter: 0
      }
    };

    console.log(imgs);

    return(
        <div className="slider-proyecto">
            <Carousel
              ssr
              partialVisbile
              showDots
              itemClass="image-item"
              autoPlaySpeed={3000}
              responsive={responsive}
              draggable
            >
              {imgs.slice(0, 5).map(image => {
                return (
                  <img
                    src={image}
                    style={{ width: "100%", paddingRight: 10, paddingLeft: 10, height: "100%" }}
                    alt={`bloques`}
                  />
                );
              })}
            </Carousel>
        </div>
    )
}

export default ProjectoSlider